<template>
  <div style="display: flex;flex-direction: row;justify-content: center;align-items: center">
    <!-- 触发按钮 -->
    <slot name="trigger" :open="open" :selectedText="displayText">
      <div @click="open"  :style="bGColor"></div>
    </slot>

    <!-- 选择器弹窗 -->
    <van-popup
        v-model="showPicker"
        position="bottom"
        round

    >
      <div class="picker-header">
        <div style="color: var(--negative-color)"
             @click="close"
        >取消</div>
        <span class="picker-title">请选择</span>
        <div
            :style="{color: `var(--${!color.hex8?'footer':'active'}-color)`}"
            @click="confirmSelection"
        >确定</div>
      </div>
      <div class="picker-content">
        <Chrome hide-select-button style="width: 100%;height: 100%" v-model="color"></Chrome>
      </div>

    </van-popup>
  </div>
</template>

<script>
import Chrome from "@/components/vue-color/components/Chrome.vue";
import ColorProcessing from "@/utils/ColorProcessing";

export default {
  name: "EvanColorPicker",
  components: {Chrome},
  props: {
    previewBorder: {
      type: String,
      default:'.3em solid var(--text-color)'
    },
    previewRadius:{
      type: String,
      default:'1.5em'
    },
    previewWidth:{
      type: String,
      default:'1.5em'
    },
    previewHeight:{
      type: String,
      default:'1.5em'
    },
    value: {
      type: [String,Object],
      default: ''
    },
    output: {
      type: String,
      default: 'all',
    },
    outputType: {
      type: String,
      default: 'obj',
    }
  },
  computed: {
    bGColor() {
      return {
        width: this.previewWidth,
        height: this.previewHeight,
        borderRadius: this.previewRadius,
        border: this.previewBorder,
        backgroundColor: this.color.hex8
      };
    },
  },
  data() {
    return{
      displayText: '',
      showPicker: false,
      color: {
        hex8: '',

      },
      previewBGColor:'#f00'

    }
  },
  methods: {
    // 打开选择器
    open() {
      this.showPicker = true;
      this.expandedItems = {};
    },

    // 关闭选择器
    close() {
      this.showPicker = false;
      this.$emit('cancel')
    },
    getOutPutData(data) {
      switch (this.outputType) {
        case 'string':
          switch (this.output) {
            case 'hsl':
              return `hsl(${data.hsl.h},${data.hsl.s}%,${data.hsl.l}%)`;
            case 'hsla':
              return `hsl(${data.hsl.h},${data.hsl.s}%,${data.hsl.l}%,${data.hsl.a})`;
            case 'hex':
              return `${data.hex}`;
            case 'rgb':
              return `rgb(${data.rgba.r},${data.rgba.g},${data.rgba.b})`;
            case 'rgba':
              return `rgb(${data.rgba.r},${data.rgba.g},${data.rgba.b},${data.rgba.a})`;
            case 'hsv':
              return `hsv(${data.hsv.h},${data.hsv.s},${data.hsv.l})`;
            case 'hsva':
              return `hsva(${data.hsv.h},${data.hsv.s},${data.hsv.l},${data.hsv.a})`;
            case  'oldHue':
              return `${data.oldHue}`;
            case 'a':
              return `${data.a}`;
            case 'hex8':
            default:
              return `${data.hex8}`
          }
          break;
        case 'obj':
        default:
          switch (this.output) {
            case 'hsl':
            case 'hsla':
              return data.hsl;
            case 'rgb':
            case 'rgba':
              return data.rgba;
            case 'hsv':
            case 'hsva':
              return data.hsv;
            case  'oldHue':
              return data.oldHue;
            case 'a':
              return data.a;
            case 'hex':
            case 'hex8':
              return data.hex8
            default:
              return data;
          }
      }
    },
    confirmSelection() {
      if (!this.color.hex8) {
        this.$toast('请先选择一项');
        return;
      }
      // 触发confirm事件

      this.$emit('confirm', this.color);
      let outputData = this.getOutPutData(this.color);

      // 触发update事件和input事件（用于v-model）
      this.$emit('update', outputData);
      this.$emit('input', outputData);
      this.close();
    },

  },
  mounted() {
    if (typeof this.value === 'object') {
      this.color = this.value;
    }
    if (typeof this.value === 'string') {
      const result = ColorProcessing.parseColor(this.value);
      if (result) {
        this.color = result;
        console.log(result)
        // 返回解析结果
        //return result;
      }
    }
  },
  watch:{


  }
}
</script>

<style scoped>

.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4em;
  padding: 15px;
  border-bottom: 1px solid var(--border-color);
}

.picker-title {
  font-size: 16px;
  font-weight: bold;
}

.picker-content {
  display: flex;
  height: calc(100% - 4em);
}

</style>
